export default __webpack_public_path__ + "static/media/SAP.9f037d19.jpg";